module.exports = __webpack_public_path__ + "img/tusi1.d3c93454.svg";